import React, { useEffect, useState } from "react";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import Swal from "sweetalert2";
import request from "../../../Helpers/API";

const MdlSolicitudCreditoCondicionadoScreen = ({ folio, setLoader, loader }) => {
    const [solicitud, setSolicitud] = useState({});

    useEffect(() => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(`ACSolicitud/Listado?folio=${folio}`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setSolicitud(result);
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("ANALISIS CREDITO", JSON.stringify(error), "error");
            });
    }, []);
    return (
        <div className="informacion-general-credito-condicionado-main-container">
            <div className="analisis-as-screen-condicionado scroll">
                <div className="analisis-as-screen-group-condicionado">
                    Folio:
                    <div>{solicitud.folio}</div>
                </div>
                <div className="analisis-as-screen-group-condicionado">
                    Cliente:
                    <div>{solicitud.cliente}</div>
                </div>
                <div className="analisis-as-screen-group-condicionado">
                    Sucursal:
                    <div>{solicitud.sucursal}</div>
                </div>
                <div className="analisis-as-screen-group-condicionado">
                    Vendedor:
                    <div>{solicitud.vendedor}</div>
                </div>
                <div className="analisis-as-screen-group-condicionado">
                    Fecha:
                    <div>{solicitud.fecha_creacion}</div>
                </div>
                <div className="analisis-as-screen-group-condicionado">
                    Tipo de solicitud:
                    <div>{solicitud.tipo_solicitud}</div>
                </div>
                <div className="analisis-as-screen-group-condicionado">
                    Linea de credito:
                    <div>{solicitud.linea_credito}</div>
                </div>
                <div className="analisis-as-screen-group-condicionado">
                    Nivel de riesgo:
                    <div>{solicitud.nivel_riesgo}</div>
                </div>
                <div className="analisis-as-screen-group-condicionado">
                    Responsable:
                    <div>{solicitud.responsable_credito}</div>
                </div>
                <div className="analisis-as-screen-group-condicionado">
                    Estatus:
                    <div>{solicitud.estado}</div>
                </div>
                <div className="analisis-as-screen-group-condicionado">
                    Monto:
                    <div>$ {FormatMoney(solicitud.importe)}</div>
                </div>
            </div>
        </div>
    );
};

export default MdlSolicitudCreditoCondicionadoScreen;

